import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TortaMovimientos from 'components/charts/e-charts/TortaMovimientos';
import { Col, Row } from 'react-bootstrap';

interface MovimientosProps {
  mtos: number;
  cap: number;
  ea: number;
  fam: number;
  geo: number;
  is: number;
  isv: number;
  lrac: number;
  msj: number;
  sag: number;
  smn: number;
  zcc: number;
}

const Movimientos = ({ mtos, cap, ea, fam, geo, is, isv, lrac, msj, sag, smn, zcc }: MovimientosProps) => {
  const issueStats = [
    { type: 'CAP', value: cap, bg: 'info-light' },
    { type: 'EA', value: ea, bg: 'warning-light' },
    { type: 'FAM', value: fam, bg: 'danger-light' },
    { type: 'GEO', value: geo, bg: 'success-light' },
    { type: 'IS', value: is, bg: 'primary' },
    { type: 'ISV', value: isv, bg: 'info-light' },
    { type: 'LRAC', value: lrac, bg: 'warning-light' },
    { type: 'MSJ', value: msj, bg: 'danger-light' },
    { type: 'SAG', value: sag, bg: 'success-light' },
    { type: 'SMN', value: smn, bg: 'primary' },
    { type: 'ZCC', value: zcc, bg: 'info-light' }
  ].sort((a, b) => b.value - a.value); // Sort in descending order based on value

  return (
    <Row className="g-3 mb-3">
      <Col xs={12} md={6}>
        <h3 className="text-body-emphasis text-nowrap">Movimientos</h3>
        <div className="d-flex align-items-center justify-content-between">
          <p className="mb-0 fw-bold">Miembro</p>
          <p className="mb-0 fs-9">
            Total <span className="fw-bold">{mtos}</span>
          </p>
        </div>
        <hr className="bg-body-secondary mb-2 mt-2" />

        {issueStats.map(issue => (
          <div className="d-flex align-items-center mb-1" key={issue.type}>
            <span
              className={`d-inline-block bg-${issue.bg} bullet-item me-2`}
            />
            <p className="mb-0 fw-semibold text-body lh-sm flex-1">
              {issue.type}
            </p>
            <h5 className="mb-0 text-body">{issue.value}</h5>
          </div>
        ))}
      </Col>
      <Col xs={12} md={6}>
        <div className="position-relative mb-sm-4 mb-xl-0">
          <TortaMovimientos
            cap={cap}
            ea={ea}
            fam={fam}
            geo={geo}
            is={is}
            isv={isv}
            lrac={lrac}
            msj={msj}
            sag={sag}
            smn={smn}
            zcc={zcc}
          />
        </div>
      </Col>
    </Row>
  );
};

export default Movimientos;